module.exports = "/assets/data/13f5891f588e07f16a04966f3cf4fbcb-W1B.data.json";